const borderStyles = {
  borderRadius: "3px"
};

export default borderStyles;
